import CrudTable from "../../../crud/CrudTable"
import {activityService as service} from "../../../../services"

const initFilter =  {
    name : null,
    code: null,
};


export default function Activity() {

  const createEstructureFilter =  [
     {
       type:"input",
       name: "name",
       col: 4
      },
  ];


  return (
    <CrudTable
          service={service}
          urledit={"/activity/edit/"}
          urlnew={"/activity/new/"}
          filter={initFilter}
          i18n={"activity"}
          fieldstable={["id","name"]}
          estructureForm={createEstructureFilter} />
  );
}
